// Mock data for OutbreakMap clone
export const DISEASES = [
  { id: 'hantavirus', name: 'Hantavirus', short: 'HPS/HFRS', color: '#22d3ee', enabled: true },
  { id: 'covid', name: 'COVID-19', short: 'SARS-CoV-2', color: '#f472b6', enabled: true },
  { id: 'ebola', name: 'Ebola', short: 'EVD', color: '#ef4444', enabled: true },
  { id: 'marburg', name: 'Marburg', short: 'MVD', color: '#a855f7', enabled: false },
  { id: 'mpox', name: 'Mpox', short: 'Monkeypox', color: '#f59e0b', enabled: true },
  { id: 'dengue', name: 'Dengue', short: 'DENV', color: '#84cc16', enabled: true },
  { id: 'zika', name: 'Zika', short: 'ZIKV', color: '#14b8a6', enabled: false },
  { id: 'h5n1', name: 'Avian Flu', short: 'H5N1', color: '#fb923c', enabled: true },
  { id: 'cholera', name: 'Cholera', short: 'V. cholerae', color: '#60a5fa', enabled: false },
  { id: 'measles', name: 'Measles', short: 'MeV', color: '#e879f9', enabled: false },
  { id: 'nipah', name: 'Nipah', short: 'NiV', color: '#fbbf24', enabled: false },
  { id: 'lassa', name: 'Lassa Fever', short: 'LASV', color: '#f87171', enabled: false },
];

export const CLASSIFICATIONS = {
  official:  { id: 'official',  label: 'Official',  color: '#ef4444', desc: 'Confirmed by WHO, CDC, ECDC, PAHO or ProMED.' },
  emerging:  { id: 'emerging',  label: 'Emerging',  color: '#f59e0b', desc: 'Corroborated across multiple independent sources.' },
  chatter:   { id: 'chatter',   label: 'Chatter',   color: '#94a3b8', desc: 'Early or isolated reports. Background signal only.' },
};

// Helper to make signals
let idc = 0;
const sig = (diseaseId, classification, lng, lat, place, country, headline, source, hoursAgo) => ({
  id: `sig_${++idc}`,
  diseaseId,
  classification,
  lng, lat,
  place,
  country,
  headline,
  source,
  hoursAgo,
});

export const SIGNALS = [
  // Hantavirus
  sig('hantavirus','official', -71.5430, -35.6751, 'Maule Region', 'Chile', 'MINSAL confirms 2 hantavirus cases in Maule', 'PAHO', 4),
  sig('hantavirus','official', -65.4232, -24.7821, 'Salta Province', 'Argentina', 'Andes virus cluster reported in northern Salta', 'ProMED', 9),
  sig('hantavirus','emerging', -106.34, 35.84, 'New Mexico', 'United States', 'Suspected Sin Nombre virus exposure on rural farm', 'CDC Surveillance', 12),
  sig('hantavirus','emerging', 127.7669, 35.9078, 'Gangwon-do', 'South Korea', 'Seoul virus seasonal HFRS uptick reported', 'KDCA', 18),
  sig('hantavirus','chatter', 9.5375, 51.1657, 'Hesse', 'Germany', 'Field worker hospitalized — Puumala suspected', 'Regional news', 26),
  sig('hantavirus','chatter', 24.9384, 60.1699, 'Uusimaa', 'Finland', 'Puumala virus chatter in forestry workers', 'YLE', 34),
  sig('hantavirus','official', -73.5673, 45.5017, 'Quebec', 'Canada', 'PHAC notes single confirmed case', 'PHAC', 50),
  sig('hantavirus','chatter', 121.4737, 31.2304, 'Shanghai', 'China', 'HFRS cluster mentioned in provincial bulletin', 'Local press', 60),

  // COVID-19
  sig('covid','official', -0.1278, 51.5074, 'London', 'United Kingdom', 'UKHSA reports XEC variant climbing 14% week-on-week', 'UKHSA', 2),
  sig('covid','emerging', 139.6917, 35.6895, 'Tokyo', 'Japan', 'Tokyo wastewater surveillance ticks up', 'NIID', 6),
  sig('covid','official', -73.9857, 40.7484, 'New York', 'United States', 'CDC: variant LP.8.1 dominant across northeast', 'CDC', 1),
  sig('covid','chatter', 28.9784, 41.0082, 'Istanbul', 'Turkey', 'Hospital occupancy mentions trending', 'Local news', 14),
  sig('covid','emerging', 77.2090, 28.6139, 'Delhi', 'India', 'INSACOG flags new lineage emergence', 'INSACOG', 8),
  sig('covid','official', 13.4050, 52.5200, 'Berlin', 'Germany', 'RKI weekly bulletin: respiratory infections rising', 'RKI', 5),

  // Ebola
  sig('ebola','official', 29.2356, -1.6792, 'North Kivu', 'DR Congo', 'WHO confirms new EVD case in North Kivu', 'WHO DON', 3),
  sig('ebola','emerging', 32.5825, 0.3476, 'Kampala', 'Uganda', 'MoH investigating possible Sudan ebolavirus exposure', 'Uganda MoH', 11),

  // Mpox
  sig('mpox','official', 15.2663, -4.4419, 'Kinshasa', 'DR Congo', 'Clade Ib mpox confirmed in additional health zones', 'WHO AFRO', 5),
  sig('mpox','emerging', 30.0619, -1.9403, 'Kigali', 'Rwanda', 'RBC: 4 new mpox cases under investigation', 'RBC', 9),
  sig('mpox','official', 2.3522, 48.8566, 'Paris', 'France', 'Santé publique France: 12 new clade II cases', 'SpF', 7),
  sig('mpox','chatter', -99.1332, 19.4326, 'Mexico City', 'Mexico', 'Press: cluster among healthcare workers', 'El Universal', 20),
  sig('mpox','official', 36.8219, -1.2921, 'Nairobi', 'Kenya', 'MoH confirms 2 imported mpox cases', 'Kenya MoH', 16),

  // Dengue
  sig('dengue','official', -46.6333, -23.5505, 'São Paulo', 'Brazil', 'PAHO: dengue cases doubled vs. same week 2025', 'PAHO', 2),
  sig('dengue','official', -74.0721, 4.7110, 'Bogotá', 'Colombia', 'INS reports widespread DENV-3 circulation', 'INS Colombia', 6),
  sig('dengue','emerging', 100.5018, 13.7563, 'Bangkok', 'Thailand', 'MoPH advisory: outbreak season starts early', 'Thai MoPH', 10),
  sig('dengue','emerging', 121.0244, 14.5547, 'Manila', 'Philippines', 'DOH dengue cases up 33% YoY', 'DOH PH', 9),
  sig('dengue','chatter', 80.2707, 13.0827, 'Chennai', 'India', 'Local hospitals report dengue ward overflow', 'The Hindu', 22),
  sig('dengue','official', -58.3816, -34.6037, 'Buenos Aires', 'Argentina', 'Ministry confirms outbreak in suburban areas', 'Argentina MoH', 12),

  // Avian Flu H5N1
  sig('h5n1','official', -119.4179, 36.7783, 'California', 'United States', 'USDA confirms H5N1 in 4 additional dairy herds', 'USDA APHIS', 1),
  sig('h5n1','emerging', -101.2996, 47.5515, 'North Dakota', 'United States', 'Suspect poultry farm under quarantine', 'USDA', 8),
  sig('h5n1','official', 4.8952, 52.3702, 'Amsterdam', 'Netherlands', 'WUR: H5N1 detected in wild geese', 'WUR', 9),
  sig('h5n1','chatter', 105.8542, 21.0285, 'Hanoi', 'Vietnam', 'Provincial reports of poultry deaths', 'VnExpress', 18),
  sig('h5n1','emerging', 116.4074, 39.9042, 'Beijing', 'China', 'NHC monitoring sporadic human exposure', 'NHC', 14),

  // Marburg (background)
  sig('marburg','official', 30.0444, -1.9536, 'Western Province', 'Rwanda', 'WHO: outbreak declared over, surveillance continues', 'WHO', 30),

  // Zika (background)
  sig('zika','chatter', -38.5108, -3.7172, 'Fortaleza', 'Brazil', 'Local press: Aedes spread, ZIKV mentions rising', 'O Povo', 26),

  // Cholera
  sig('cholera','official', 33.7741, 35.1264, 'Beirut', 'Lebanon', 'MoPH confirms cluster in displaced population', 'Lebanon MoPH', 7),
  sig('cholera','emerging', 36.8219, 15.5007, 'Khartoum', 'Sudan', 'WHO Sudan: acute watery diarrhea surge', 'WHO', 11),

  // Measles
  sig('measles','official', -95.7129, 31.9686, 'Texas', 'United States', 'TDSHS confirms 6 additional measles cases', 'TDSHS', 6),
  sig('measles','emerging', -3.7038, 40.4168, 'Madrid', 'Spain', 'ISCIII: cluster among unvaccinated children', 'ISCIII', 13),

  // Nipah
  sig('nipah','official', 76.2711, 9.9312, 'Kerala', 'India', 'Kerala MoH confirms Nipah virus case', 'Kerala MoH', 4),

  // Lassa Fever
  sig('lassa','official', 7.4951, 9.0820, 'Abuja', 'Nigeria', 'NCDC weekly bulletin: 7 new confirmed cases', 'NCDC', 10),
];

